<script>
/**
 * ****************************************************************************
 * @description     :   Header
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
/**
 * Import libraries
 */
import { mapMutations, mapState } from 'vuex';
import _ from 'lodash';

/**
 * import template
 */
import template from './template.html';

import ChangeUser from '@/views/popup/changeUser';
import { MobileMenu, NeedMoreCheck } from '@/shared/menu/menu';
import helpers from '@/utils/helpers';

/**
 * Define main layout
 */
const Header = {
    name: 'Header',
    template: template,
    components: {
        ChangeUser
    },
    data() {
        return {
            activeMenuId: 0,
            menus: [...MobileMenu],
            permission: helpers.permission(),
            isSwitchUser: helpers.isSwitchUser(),
            showModal: false,
            isOpenMobileMenu: false
        };
    },
    computed: {
        ...mapState('app', [
            'homeScreen',
            'loginScreen',
            'menuPermission',
            'screenId',
            'user',
            'isPublic',
            'isMobile'
        ]),
        screenName() {
            if (this.$route.name == 'Gm0061v') {
                return 'アラート詳細';
            } else {
                return (
                    _.find(this.menus, (x) => {
                        return x.isActive;
                    })?.name ?? ''
                );
            }
        }
    },
    watch: {
        menuPermission() {
            setTimeout(() => {
                this.checkPermission();
                this.setActiveItem();
            }, 100);
        },
        user() {
            setTimeout(() => {
                this.permission = helpers.permission();
                this.isSwitchUser = helpers.isSwitchUser();
                this.checkPermission();
            }, 100);
        },
        'user.switchUser'() {
            setTimeout(() => {
                this.permission = helpers.permission();
                this.isSwitchUser = helpers.isSwitchUser();
                this.checkPermission();
            }, 100);
        },
        screenId() {
            setTimeout(() => {
                this.setActiveItem();
            }, 100);
        },
        isMobile() {
            setTimeout(() => {
                this.setActiveItem();
            }, 100);
        }
    },
    mounted() {
        this.checkPermission();
    },
    methods: {
        ...mapMutations('app', ['resetAppState', 'setLogout']),
        activeMenu(id) {
            this.activeMenuId = id;
            if (id == 1) {
                this.showModal = true;
            }
        },
        onClickOutside() {
            this.activeMenuId = 0;
        },
        logout: function () {
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('tokenTimeout');
            sessionStorage.removeItem('switchUser');
            this.resetAppState();
            this.$router.push(this.loginScreen);
        },
        setActiveItem() {
            const length = this.menus.length;
            const pathname =
                window.location.pathname === '/'
                    ? ''
                    : window.location.pathname;
            for (let i = 0; i < length; i++) {
                if (this.menus[i].url === pathname) {
                    this.menus[i].isActive = true;
                } else {
                    this.menus[i].isActive = false;
                }
            }
        },
        checkPermission() {
            const length = this.menus.length;
            for (let i = 0; i < length; i++) {
                if (this.menus[i].role.includes(this.permission)) {
                    this.menus[i].hadPermission = true;
                    if (
                        NeedMoreCheck[this.permission]?.includes(
                            this.menus[i].id
                        )
                    ) {
                        const per = _.findLast(this.menuPermission, {
                            機能ID: this.menus[i].id
                        });
                        if (
                            !(
                                per &&
                                ((this.menus[i].isCheck利用者権限 &&
                                    per.利用者権限 == 1) ||
                                    (!this.menus[i].isCheck利用者権限 &&
                                        per.上司権限 == 1))
                            )
                        ) {
                            this.menus[i].hadPermission = false;
                        }
                    }
                } else {
                    this.menus[i].hadPermission = false;
                }
            }
        },
        onOpenLink() {
            const link = this.user.ヘルプサイト;
            if (helpers.isNullOrEmpty(link)) {
                return;
            }
            window.open(link, '_blank');
        }
    }
};
export default Header;
</script>
